module.exports = function() {
  return new Worker(__webpack_public_path__ + "1994e144a22d1f5a9b94.worker.js");
};